import React, { Component } from 'react'
import * as mat from 'material-ui'
import { connect } from 'react-redux';
import './style.css'
import dummy from '../images/faculty.png';
import Dropzone from 'react-dropzone';
import { SaveEditProfile } from '../../action/editAction'
import GoOrganization from 'react-icons/lib/go/organization'
import GoHome from 'react-icons/lib/go/home'

class EditProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            img: '',
            infoImg: this.props.info.profile,
            array: [],
            errormessage: '',
            value:''
        }
        this.handleChange = this.handleChange.bind(this);
    }
    onDrop(files) {
        var file = files[0];
        this.state.array.push(file);
        this.setState({ img: file.name })
    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    SaveProfile() {
        let userName = this.refs.userName.value;
        let email = this.refs.email.value;
        let schoolName = this.refs.schoolName.value;
        let students = this.refs.students.value;
        let schoolAddress = this.refs.schoolAddress.value;
        let phone = this.refs.phone.value;
        let schoolType = this.state.value

        let save = {
            userName,
            email,
            phone,
            schoolName,
            students,
            schoolType,
            schoolAddress,
            profile: this.state.img === '' ? this.state.infoImg : this.state.img,
            role: this.props.info.role,
            uid: this.props.info.uid,
            file: this.state.array
        }
        console.log('save', save)
        this.props.SaveEditProfile(save);



    }
    render() {
        const {
            info,
            Loader,
            sucess
        } = this.props;
        console.log('info', info)
        return (
            <div className='profile'>
                {/* <div > */}
                <mat.Card zDepth={0} className='col-md-6 col-md-offset-3 col-xs-10 col-xs-offset-1'>
                    <mat.AppBar
                        title='Edit Admin'
                        titleStyle={{ textShadow: '0px 1px 2px #cccccc', fontSize: '2em', fontWeight: 'normal', color: '#000000' }}
                        showMenuIconButton={false}
                        style={{ backgroundColor: 'white' }}
                        zDepth={0}
                    />
                    <mat.CardText >
                        <mat.Divider />
                    </mat.CardText >
                    <mat.CardText >
                        <div className='text-center'>
                            <mat.Avatar
                                src={info.profile === 'https' ? info.profile = dummy : info.profile}
                                size={130}
                            />
                        </div>
                        <br />
                        <div className='col-md-12'>
                            <Dropzone
                                className=' text-center col-md-4 col-md-offset-4'
                                style={{
                                    paddingTop: '1%',
                                    paddingBottom: '1%',
                                    marginBottom: '1%',
                                    backgroundColor: '#f2f2f2',
                                    border: 'none',
                                    cursor: 'pointer',
                                }}
                                onDrop={this.onDrop.bind(this)}
                            >
                                {(this.state.img === '') ? (
                                    <span style={{ color: 'black' }}>Upload new Image</span>
                                ) : (
                                        <span style={{ color: 'black' }}>{this.state.img}</span>
                                    )}

                            </Dropzone>
                        </div>

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-user"></i></span>
                            <input
                                ref="userName"
                                className="form-control"
                                aria-label="admin"
                                required
                                defaultValue={info.userName}
                                aria-describedby="sizing-addon1"
                            />
                        </div>
                        <br />
                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-envelope"></i></span>
                            <input
                                ref="email"
                                className="form-control"
                                defaultValue={info.email}
                                disabled={true}
                                aria-label="Email"
                                required
                                aria-describedby="sizing-addon1"
                            />
                        </div>
                        <br />
                        {/* CHANGING START */}

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-earphone"></i></span>
                            <input
                                required
                                ref="phone"
                                defaultValue={info.phone}
                                className="form-control"
                                placeholder="Enter Phone Number"
                                type='number'
                            />
                        </div>
                        <br />

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-education"></i></span>
                            <input
                                required
                                ref="schoolName"
                                defaultValue={info.schoolName}
                                className="form-control"
                                placeholder="Enter School Name"
                            />
                        </div>
                        <br />

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><GoOrganization /></span>
                            <input
                                required
                                ref="students"
                                defaultValue={info.students}
                                className="form-control"
                                placeholder="Enter No. of Students"
                                type='number'
                            />
                        </div>
                        <br />

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><GoOrganization /></span>

                            <select className="form-control" defaultValue={info.schoolType} onChange={this.handleChange}>
                                <option value="independent">Independent</option>
                                <option value="government">Government</option>
                                <option value="autonomous">Autonomous</option>
                                <option value="private">Private</option>
                                <option value="international">International</option>
                            </select>
                        </div>
                        <br />

                        <div className="input-group input-group-lg">
                            <span className="input-group-addon"><GoHome /></span>
                            <input
                                required
                                ref="schoolAddress"
                                defaultValue={info.schoolAddress}
                                className="form-control"
                                placeholder="Enter School Address"
                            />
                        </div>
                        <br />
                        {/* CHANGING END         */}

                        {/* <div className="input-group input-group-lg">
                            <span className="input-group-addon"><i className="glyphicon glyphicon-lock"></i></span>
                            <input
                                name="password"
                                className="form-control"
                                aria-label="Password"
                                required
                                type="password"
                                aria-describedby="sizing-addon1"
                            />
                        </div> 
                        <br />*/}
                        <div className='col-md-12 text-center' style={{ color: 'blue', fontSize: 18 }}>
                            {sucess}
                        </div>
                        <div className='col-md-12 text-center' style={{ color: 'red', fontSize: 18 }}>
                            {this.state.errormessage}
                        </div>
                        <div className="btn-group btn-group-lg btn-group-justified">
                            {(Loader === false) ? (
                                <a onClick={this.SaveProfile.bind(this)} className="btn btn-info" >Save Profile</a>
                            ) : (
                                    <div className='text-Center'>
                                        <mat.LinearProgress mode="indeterminate" color='#1e5a89' />
                                    </div>
                                )}
                        </div>
                    </mat.CardText>
                </mat.Card>
                {/* {(error === false) ? (
                    <mat.Snackbar
                        open={snackBars}
                        message="Check your connection and add again"
                        autoHideDuration={3000}
                        contentStyle={{ color: 'white' }}
                        bodyStyle={{ backgroundColor: '#f44336' }}
                    />
                ) : (
                        <mat.Snackbar
                            open={snackBars}
                            message="Your Profile Updated"
                            autoHideDuration={3000}
                            contentStyle={{ color: 'white' }}
                            bodyStyle={{ backgroundColor: '#2eda2c' }}
                        />
                    )} */}
                {/* </div> */}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        info: state.editReducers.userInfo,
        Loader: state.editReducers.loader,
        sucess: state.editReducers.message,
        // error: state.QuizReducders.error,
    };
}
const mapDispatchToProps = (dispatch) => {
    return {
        // QuizCreated: (quizData) => {
        //     dispatch(QuizCreated(quizData));
        // },
        SaveEditProfile: (file) => {
            dispatch(SaveEditProfile(file));
        }
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(EditProfile);


// WEBPACK FOOTER //
// ./src/component/editProfile/editProfile.jsx